import React, { useState } from 'react';
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material';
import LEDCodesTable from '../components/dashboard/LEDCodesTable';
import LEDCodesV3 from '../components/dashboard/LEDCodesV3';

/**
 * Les deux firmwares n'utilisent pas le même code de signalisation. La V2
 * encode les défauts en nombre d'impulsions rouges. La V3, sur carte
 * MPB_RPI4B-V3.0, dispose d'un voyant RGB et attribue une couleur par type de
 * défaut. L'onglet doit correspondre à la génération de carte du boîtier.
 */

const LEDCodesPage: React.FC = () => {
  const [onglet, setOnglet] = useState(0);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Codes LED des boîtiers
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        Le code diffère selon la génération de carte. Vérifiez la version du
        boîtier avant de lire un onglet.
      </Typography>

      <Paper sx={{ p: 2 }}>
        <Tabs
          value={onglet}
          onChange={(_, v) => setOnglet(v)}
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
        >
          <Tab label="V3 — voyant RGB" />
          <Tab label="V2 — deux voyants" />
        </Tabs>

        {onglet === 0 && <LEDCodesV3 />}
        {onglet === 1 && <LEDCodesTable />}
      </Paper>
    </Box>
  );
};

export default LEDCodesPage;
